import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
 
  textInputStyle: {
    width: 350,
  },
  width100: {
    width: 100,
  },
}));
